import { SPACE_150 } from '@alltrails/denali/tokens';
import type { MarkerProperties } from '@alltrails/types/CustomRoute';
import PaddingAwarePopup from '../../PaddingAwarePopup';
import styles from './PositionTooltip.module.scss';
import { useMemo } from 'react';

const PositionTooltip = (props: MarkerProperties) => {
  const { latitude, longitude, position } = props;

  const tooltipText = useMemo(() => {
    return position === 'top' ? 'Back selected' : position === 'bottom' ? 'Out selected' : 'Both selected';
  }, [position]);

  return (
    <PaddingAwarePopup
      className={styles.container}
      latitude={latitude}
      longitude={longitude}
      offset={{
        bottom: [0, -SPACE_150],
        'bottom-left': [0, -SPACE_150],
        'bottom-right': [-SPACE_150, 0],
        top: [0, SPACE_150],
        'top-left': [SPACE_150, SPACE_150],
        'top-right': [-SPACE_150, SPACE_150],
        left: [0, SPACE_150],
        right: [-SPACE_150, 0]
      }}
      closeButton={false}
      closeOnClick={false}
      focusAfterOpen={false}
    >
      <div className={styles.tooltip}>{tooltipText}</div>
    </PaddingAwarePopup>
  );
};

export default PositionTooltip;
